export * from "./brandReport.constants";
export * from "./restaurants.constants";
export * from "./userProfile.constants";
export * from "./brandConfiguration.constant";
export * from "./performance.constants";
export * from "./loginUnitTest.constant";
export * from "./storeProfile.constants";
export * from "./surveyQuestion.constant";
export * from "./customerSurvey.constants";
export * from "./brandPerformance.constant";
export * from "./consumerResponse.constant";
export * from "./campaignMetrics.constants";
export * from "./googleSocialLink.constants";
export * from "./userPermissionTest.constant";
export * from "./themeSettingsUnitTest.constants";
export * from "./individualGroupPerformance.constants";
export * from "./individualStorePerformance.constants";
export * from "./groupPerformance.constants";
export * from "./managerPerformance.constants";
export * from "./marketingSales.constants";
export * from "./surveyQueues.constants";
export * from "./inbox.constants";
export * from "./changeSurveyPreferences.constants";
export * from "./setupTests.constants";

//Roles use in all unit tests
export const roleConstants = {
  ROLE_ROW: "row",
  ROLE_TAB: "tab",
  ROLE_LINK: "link",
  ROLE_IMAGE: "img",
  ROLE_TABLE: "table",
  ROLE_RADIO: "radio",
  ROLE_GROUP: "group",
  ROLE_ALERT: "alert",
  ROLE_DIALOG: "dialog",
  ROLE_BUTTON: "button",
  ROLE_SWITCH: "switch",
  ROLE_HEADING: "heading",
  ROLE_TABLE_CELL: "cell",
  ROLE_TEXT_BOX: "textbox",
  ROLE_COMBOBOX: "combobox",
  ROLE_CHECKBOX: "checkbox",
  ROLE_TAB_PANEL: "tabpanel",
  ROLE_LIST_ITEMS: "listitem",
  ROLE_NAVIGATION: "navigation",
  ROLE_SPIN_BUTTON: "spinbutton",
  ROLE_PROGRESS_BAR: "progressbar",
  ROLE_COLUMN_HEADER: "columnheader",
};

export const unitTestInputTypeConstants = {
  TYPE: "type",
  TYPE_TEXT: "text",
  TYPE_EMAIL: "email",
  TYPE_SUBMIT: "submit",
  TYPE_PASSWORD: /password/i,
  TYPE_PASSWORD_S: "password",
};

export const unitTestSuccessToastMessage = {
  SUCCESSFULLY_UPDATED: /successfully updated/i,
  ADD_USER_SUCCESS_TOAST:
    /User has been successfully created. Please check the provided email to verify account/i,
};
export const unitTestErrorToastMessage = {
  FILL_ALL_QUESTION_ERROR_MESSAGE:
    /please fill all question fields and save survey!/i,
  SELECT_ONE_PLEASE: /select one please/i,
  SOMETHING_WENT_WRONG: /Something went wrong/i,
};

export const unitTestsEmailsAndName = {
  TEST_MANAGER_NAME: "Unit Test Manager",
  TEST_BRAND_ADMIN_NAME: "Test Brand Admin",
  TEST_SUPER_ADMIN_NAME: "Unit Test Super Admin",
  TEST_FRANCHISE_ADMIN_NAME: "Test Franchise Admin",
  TEST_MANAGER_EMAIL: "unittestmanager@email.com",
  TEST_BRAND_ADMIN_EMAIL: "testbrandadmin@email.com",
  TEST_SUPER_ADMIN_EMAIL: "unittestsuperadmin@email.com",
  TEST_FRANCHISE_ADMIN_EMAIL: "testfranchiseadmin@email.com",
};

export const commonUnitTestNames = {
  BLANK_PAGE: "_blank",
  TEST_FRANCHISE: "testfranchise",
  MANAGER_TEST2: "managertest2",
};

//Constants for the commonly used data-test id's
export const commonUnitTestsIdsConstants = {
  LIST: "list",
  CLOSE: "Close",
  TOGGLE_BUTTON: "toggle-button",
  EMPTY_SEARCH_BUTTON: "empty-search",
  CLICKABLE_RESTAURANT: "clickable-restaurant",
  RESTAURANT_INFO_POPUP: "restaurant-info-popup",
  PHOTO_UPLOADER: "photo-uploader",
  TABLE_ROWS: "tableRows",
  TABLE_HEADER: "tableHeader",
  PAGINATION: "pagination",
  PAGE_SIZE_SELECT: "page-size-select",
  PAGE_NUMBER_INPUT: "page-number-input",
  MONAL_RESTO: "Monal Resto",
  SOURCE_DROPDOWN: "sourceDropDown",
  EVENT_DATE: "event-date",
  FROM_DATE: "from-date",
  TO_DATE: "to-date",
  EXPANDABLE_TABLE: "expandable-tables",
};

export const unitTestIds = {
  MANAGER_ID_51: 51,
  MANAGER_ID_67: 67,
  MANAGER_ID_88: 88,
  GROUP_ID_205: 205,
  GROUP_ID_206: 206,
  GROUP_ID_207: 207,
  GROUP_ID_192: 192,
  GROUP_ID_173: 173,
  GROUP_ID_216: 216,
  GROUP_ID_183: 183,
  GROUP_ID_237: 237,
  GROUP_ID_260: 260,
  GROUP_ID_272: 272,
  STORE_ID_FR: 1188,
  STORE_ID_1539: 1539,
  USER_ID_10522: 10522,
  USER_ID_10714: 10714,
  USER_ID_10724: 10724,
  USER_ID_10725: 10725,
  USER_ID_10959: 10959,
  USER_ID_11016: 11016,
  USER_ID_11027: 11027,
  USER_ID_21511: 21511,
  QUESTION_ID_160: 160,
  QUESTION_ID_200: 200,
  QUESTION_ID_207: 207,
  KHAN_BRAND_ID: 10073,
  DEV_TEST_BRAND_ID: 10162,
  TEST_SURVEY_BRAND_ID: 10239,
  STORE_ID_10109: 10109,
  STORE_ID_10107: 10107,
  STORE_ID_10112: 10112,
  STORE_ID_10113: 10113,
  CUSTOMER_ID_1864380: 1864380,
  STORE_ID_10133: 10133,
  STORE_ID_10198: 10198,
  STORE_ID_10131: 10131,
  STORE_ID_10127: 10127,
  STORE_ID_10138: 10138,
  SURVEY_BRAND_ID: 10072,
  CUSTOMER_ID_1071: 1071,
  BRAND_ID: 10162,
  SURVEY_QUESTION_CATEGORY: 1,
  ORDER_ID_1042: 1042,
  FROM_DATE: "\\d+",
  TO_DATE: "\\d+",
  CONVERSATION_ID_10160: 10160,
  CONVERSATION_ID_10267: 10267,
  CUSTOMER_ID_1076: 1076,
  CUSTOMER_ID_1047: 1047,
  ORDER_ID: 9023419,
};

export { BASE_URL } from "../apiUrls";
export const SIGNAL_R = "http://localhost:58726";
